import { combineReducers } from 'redux'
import { authentication } from './authentication'
import { app } from './app'
import { common } from './common';
import { alert } from './alert';
import { notification } from './notification';
import { connectRouter } from 'connected-react-router'
import { reducer as formReducer } from 'redux-form'
import { user } from './user'
import { area } from './area'
import { service } from './service'
import { product } from './product'
import { guarantee } from './guarantee'
import { fixture } from './fixture'
import { warehouse } from './warehouse'
import { transaction } from './transaction'
import { order } from './order'
import { financial } from './financial'
import { settings } from './settings'
import { pos } from './pos'
import { dashboard } from './dashboard'
import { reminder } from './reminder'
import { report } from './report'


export default (history) => combineReducers({
    router: connectRouter(history),
    form: formReducer,
    app: app,
    auth: authentication,
    common: common,
    alert: alert,
    notification: notification,
    user: user,
    area: area,
    service: service,
    product: product,
    guarantee: guarantee,
    fixture: fixture,
    warehouse: warehouse,
    transaction: transaction,
    order: order,
    financial: financial,
    settings: settings,
    pos: pos,
    dashboard: dashboard,
    reminder: reminder,
    report: report,
});
